angular.module("siter.io").controller "DashboardWebForms", ["$scope", "$rootScope", "$state", "$timeout", "Site", "Modal", "Template", "$location", "Section", "Widget", "Notification", "WebForm", ($scope, $rootScope, $state, $timeout, Site, Modal, Template, $location, Section, Widget, Notification, WebForm) ->

  if window.justclick.currentUser.role is "client"
    $location.path '/404'

  $rootScope.site = {}
  $scope.state = $state
  $scope.currentState = $state.current.name
  $scope.tagobject = {tagName:""}
  $scope.scrollDisabled = false
  $scope.webForms = []

  $scope.getHomePagePath = (pages) ->
    return false if pages.length is 0
    homePage = _.filter pages, home: true
    homePage[0].path

  $rootScope.refreshWebFormTemplates = ->
    $scope.webFormsLoading = true
    Template.getWebFormTemplates().then (webForms) ->
      $scope.webForms = webForms
      $scope.webFormsCount = webForms.length
      $scope.webFormsLoading = false

  refreshWebFormTags = ->
    Template.getWebFormUserCategories().then (tags) ->
      $scope.webFormTemplatesTags = tags

  $scope.treeWebFormOptions =
    dropped: (e) ->
      $timeout ->
        Template.sortWebFormCategories($scope.webFormTemplatesTags).then (tags) ->
          $scope.webFormTemplatesTags = tags
      return

  $scope.webFormSectionsLoading = true

  #load sections for email

  $scope.removeWebFormTemplate = (collection, form) ->
    findedForm = _.filter collection, {id: form.id}
    index = collection.indexOf findedForm[0]
    $rootScope.alertDialog
      title: "Deleting a form template"
      text: "Are you sure you want to delete this form template?"
      accept_text: "Yes"
      cancel_text: "Cancel"
      accept: ->
        WebForm.remove(form.id).then ->
          collection.splice index, 1

  $scope.saveWebFormTemplate = (template) ->
    WebForm.update template

  listener3 = $rootScope.$on "web_form:created", (e, newWebForm, template = false) ->
    if template
      template.childs.push newWebForm
    else
      $scope.webForms.push newWebForm
    refreshWebFormTags()

  listener4 = $rootScope.$on "web_form:updated", (e, newWebForm, template = false) ->
    refreshWebFormTags()

  refreshWebFormTags()
  $rootScope.refreshWebFormTemplates()

  $scope.$on "$destroy", ->
    listener3()
    listener4()

  # modals
  $scope.newWebFormTemplate = Modal.newWebFormTemplate
  $scope.editWebFormTemplate = Modal.editWebFormTemplate
]



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboardWebforms.controller.coffee